import classes from "./cta_aboutUs.module.css";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const CtaAboutUs = () => {
  const storedLang = localStorage.getItem("lang");
  let lng = storedLang ?? navigator.language;
  const { t, i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(lng);
  }, [lng, i18n]);

  return (
    <section className={classes["cta-section"]} id="about_us">
      <div
        className={`${classes.container} ${classes["cta-section--headers"]}`}
      >
        <h3>{t("cta.subtitle")}</h3>
        <h1>{t("cta.title")}</h1>
      </div>
      <div className={`${classes.container} ${classes.grid}`}>
        <div className={classes["about-us--box"]}>
          <div>
            <div className={classes["green-rectangle"]}></div>
          </div>
          <div className={classes["about-us"]}>
            <h4 className={classes["about-us--title"]}>
              {t("cta.who_we_are")}
            </h4>
            <p className={classes["about-us--description"]}>
              {t("cta.description")}
            </p>
          </div>
        </div>
        <div className={classes["cta-box"]} id="contact">
          <div className={classes.cta}>
            <form className={classes.form} action="#">
              <div>
                <label className={classes.label} htmlFor="email">
                  {" "}
                  {t("cta.email_label")}
                </label>
                <input
                  className={classes.input}
                  type="email"
                  id="email"
                  placeholder={t("cta.email_placeholder")}
                  required
                />
              </div>
              <div>
                <label className={classes.label} htmlFor="subject">
                  {" "}
                  {t("cta.subject_label")}
                </label>
                <input
                  className={classes.input}
                  type="text"
                  id="subject"
                  placeholder={t("cta.subject_placeholder")}
                  required
                />
              </div>
              <div>
                <label className={classes.label} htmlFor="desciption">
                  {" "}
                  {t("cta.description_label")}
                </label>
                <textarea
                  className={classes["text-area--description"]}
                  name="desciption"
                  id="desciption"
                  rows={7}
                  placeholder={t("cta.description_placeholder")}
                  required
                ></textarea>
              </div>
            </form>
            <a className={classes["btn-link"]} href="#">
              {" "}
              {t("cta.button_text")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaAboutUs;
